import {
  FileText,
  Image,
  Film,
  MessageCircle,
  BarChart3,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

// 服务分类配置
export interface ServiceCategory {
  id: string
  name: string
  icon: LucideIcon
  description: string
  color: {
    bg: string // Background color
    text: string // Text color
    border: string // Border color
    badge: string // Badge/chip styles
    accent: string // Hex color for accents
  }
}

export const SERVICE_CATEGORIES: ServiceCategory[] = [
  {
    id: 'text',
    name: '文本处理',
    icon: FileText,
    description: '文本生成、处理、翻译等相关服务',
    color: {
      bg: 'bg-blue-50',
      text: 'text-blue-700',
      border: 'border-blue-200',
      badge: 'bg-blue-100 text-blue-700 border-blue-200',
      accent: '#3b82f6'
    }
  },
  {
    id: 'image',
    name: '图片生成',
    icon: Image,
    description: '图像生成、处理、分析相关服务',
    color: {
      bg: 'bg-pink-50',
      text: 'text-pink-700',
      border: 'border-pink-200',
      badge: 'bg-pink-100 text-pink-700 border-pink-200',
      accent: '#ec4899'
    }
  },
  {
    id: 'media',
    name: '多媒体',
    icon: Film,
    description: '视频、音频生成与处理相关服务',
    color: {
      bg: 'bg-purple-50',
      text: 'text-purple-700',
      border: 'border-purple-200',
      badge: 'bg-purple-100 text-purple-700 border-purple-200',
      accent: '#9333ea'
    }
  },
  {
    id: 'conversation',
    name: '对话交互',
    icon: MessageCircle,
    description: '智能对话、问答、客服相关服务',
    color: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-700',
      border: 'border-emerald-200',
      badge: 'bg-emerald-100 text-emerald-700 border-emerald-200',
      accent: '#10b981'
    }
  },
  {
    id: 'data',
    name: '数据分析',
    icon: BarChart3,
    description: '数据分析、可视化、图表生成相关服务',
    color: {
      bg: 'bg-orange-50',
      text: 'text-orange-700',
      border: 'border-orange-200',
      badge: 'bg-orange-100 text-orange-700 border-orange-200',
      accent: '#f97316'
    }
  },
  {
    id: 'other',
    name: '其他',
    icon: Wrench,
    description: '其他类型服务',
    color: {
      bg: 'bg-gray-50',
      text: 'text-gray-700',
      border: 'border-gray-200',
      badge: 'bg-gray-100 text-gray-700 border-gray-200',
      accent: '#6b7280'
    }
  }
]

// 根据 ID 获取分类
export function getCategory(id: string): ServiceCategory | undefined {
  return SERVICE_CATEGORIES.find(cat => cat.id === id)
}

// 获取所有分类 ID
export function getAllCategoryIds(): string[] {
  return SERVICE_CATEGORIES.map(cat => cat.id)
}
